// src/stockx/line/LogoutIcon.tsx
import { createIcon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var LogoutIcon = createIcon({
  displayName: "LogoutIcon",
  viewBox: "0 0 50 50",
  path: /* @__PURE__ */ jsxs("g", { fill: "currentColor", children: [
    /* @__PURE__ */ jsx("path", { d: "M21 39.7H5.5V10.3H21V13.3H8.5V36.7H21V39.7Z" }),
    /* @__PURE__ */ jsx("path", { d: "M30.3 10.8L28.2 12.9L38.7 23.5H17V26.5H38.8L28.3 37.1L30.4 39.2L44.5 25L30.3 10.8Z" })
  ] })
});
var LogoutIcon_default = LogoutIcon;

export {
  LogoutIcon_default
};
